/**
 * 给传入的数据脱敏显示，返回xxxx****xxx,与全局指令v-dataPrivacy规则保持一致
 * @param {String} realText
 * @param {String} type: 默认是中间加密: 'center': 中间加密，'end'：后端加密
 * @returns
 */
export function dataPrivacy(realText, conf = {}) {
  let handleObj = null

  const { type = 'center' } = conf

  // 数字0赋值为'0', 因为 '0' 为 true
  if (realText === 0) {
    realText = '0'
  }

  if (!realText) {
    return ''
  }

  // 过滤空格
  realText = realText.replace(/\s*/g, '')

  // 'center': 中间加密，'end'：后端加密
  if (type === 'center') {
    handleObj = centerPricacy(realText)
  } else if (type === 'end') {
    handleObj = endPrivacy(realText)
  } else {
    handleObj = {
      realText,
      startLen: '',
      endLen: ''
    }
  }

  return matchRule(handleObj)
}

/**
 * 脱敏匹配规则函数
 * @param {*} realText
 * @returns
 */
export function matchRule({ realText = '', startLen, endLen } = {}) {
  // eslint-disable-next-line
  const reg = new RegExp(`^(\\S{${startLen}})(\\S+)(\\S{${endLen}})$`);
  const res = realText.match(reg)
  if (!res) return realText
  const [, one, two, three] = res || []
  let len = two.length
  let unkn = ''
  while (len) {
    len--
    unkn += '*'
  }
  const text = one + unkn + three
  return text
}

/**
 * 中间脱敏，返回***xxxxxxx****
 * @param {String} realText
 * @param {Number} startLen: 3
 * @param {Number} endLen: 4
 * @returns
 */
export function centerPricacy(realText = '', startLen = 3, endLen = 4) {
  if (realText.length < 3) {
    // 小于3位时,都加密
    startLen = 0
    endLen = 0
  } else if (realText.length < 7) {
    // 小于7位时,展示前1位和后1位
    startLen = 1
    endLen = 1
  } else if (realText.length < 9) {
    // 小于9位时,展示前2位和后2位
    startLen = 2
    endLen = 2
  }
  return {
    realText,
    startLen,
    endLen
  }
}

/**
 * 后面，返回xxxxx****
 * @param {String} realText
 * @param {Number} startLen: 0
 * @param {Number} endLen: 0
 * @returns
 */
export function endPrivacy(realText = '', startLen = 0, endLen = 0) {
  if (realText.length <= 7) {
    // 地址小于7位时,都加密
    startLen = 0
    endLen = 0
  } else if (realText.length <= 12) {
    // 大于7位，小于12位时,7位以后的位置都加密
    startLen = 7
    endLen = 0
  } else {
    // 大于12位时,第10位的位置开始加密
    startLen = 9
    endLen = 0
  }

  return {
    realText,
    startLen,
    endLen
  }
}



// WEBPACK FOOTER //
// ./src/m-common/lib/util/dataPrivacy.js